import serverConnection from '../common/server-connection.js';

export default function() {
  var storylineSlider = tns({
      container: '.storyline-slider',
      items: 1,
      slideBy: 'page',
      mouseDrag: true,
      nav: true,
      autoplay: true,
      controlsText: ["<span></span>","<span></span>"]
    });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/storyline.js